import { registerBigNumberSerializers } from '@ftr/serialization/registerBigNumberSerializers';
import { registerJavascriptSerializers } from '@ftr/serialization/registerJavascriptSerializers';
import { registerJodaSerializers } from '@ftr/serialization/registerJodaSerializers';
import { serializerRegistrations } from '@ftr/serialization/serializerRegistrations';
import { LineItem as ApiLineItem, apiLineItemSerializer, LineItemRequest, lineItemRequestSerializer, PriceCalculationParams, priceCalculationParamsSerializer, } from '../api/order';
import { AUDIO_OBJECT_SERIALIZER_IDENTIFIER, audioObjectSerializer } from '../message/recording/AudioObjectSerializer';
// Avoiding using barrels for 'message' contracts as it makes ftr-web
// import all of the message folder (when it only needs a few)
import { TrmConversionResult } from '../message/recording/TrmConversionResult';
import { trmConversionResultSerializer } from '../message/recording/TrmConversionResultSerializer';
import { ChargeMetadata, LineItem, lineItemSerializer, ModifyLineItemProperties, modifyLineItemPropertiesSerializer, } from '../type/order';
import { chargeMetadataSerializer } from '../type/order/ChargeMetadataSerializer';
let isRegistered = false;
export function registerContractSerializers() {
    if (isRegistered) {
        return;
    }
    registerBigNumberSerializers();
    registerJavascriptSerializers();
    registerJodaSerializers();
    const contractSerializers = [
        { type: PriceCalculationParams, serializer: priceCalculationParamsSerializer },
        { type: LineItem, serializer: lineItemSerializer },
        { type: ApiLineItem, serializer: apiLineItemSerializer },
        { type: LineItemRequest, serializer: lineItemRequestSerializer },
        { type: ModifyLineItemProperties, serializer: modifyLineItemPropertiesSerializer },
        { type: TrmConversionResult, serializer: trmConversionResultSerializer },
        { type: AUDIO_OBJECT_SERIALIZER_IDENTIFIER, serializer: audioObjectSerializer },
        { type: ChargeMetadata, serializer: chargeMetadataSerializer },
    ];
    serializerRegistrations.push(...contractSerializers);
    isRegistered = true;
}
